const USER_TYPE = {
    STUDENT: 'STUDENT',
};

export default USER_TYPE;
